export default function formatValue(value: any, config?: any) {
  if (Array.isArray(value)) {
    if (!value.some((v: any) => typeof v === 'object')) return value;

    return value
      .reduce((acc, cur) => acc + cur.text.concat(', '), '')
      .slice(0, -2);
  } else if (typeof value === 'object') {
    return value.text ?? value.label ?? value.key;
  }
  return value;
}
